import {
    type UscExternalPriceActionsType,
    USC_EXT_PRICE_FAILED,
    USC_EXT_PRICE_SET_DATA,
    USC_EXT_PRICE_SET_SHOW,
    USC_EXT_PRICE_SET_FETCHING,
    USC_EXT_PRICE_SET_LOCATION,
} from "../actions/UscExternalPriceActions";
import type { ExternalPriceResponseType, ExternalPricePayloadType } from "../../utils/externalPriceTypes";

export type UscExternalPriceReducerType = {
    show: boolean;
    failed: boolean;
    errorMessage: string | null;
    fetching: boolean;
    data: ExternalPriceResponseType | null;
    latestPayload: ExternalPricePayloadType | null;
    userTaxLocationId: string | null;
};

export const initialStateUscExternalPrice: UscExternalPriceReducerType = {
    show: false,
    failed: false,
    fetching: false,
    data: null,
    latestPayload: null,
    errorMessage: null,
    // This is a string referring to one of the taxLocations in uscSettings.taxLocations.
    // It is an id and not a complete object as that makes it a lot easier to deal with during data fetching.
    userTaxLocationId: null,
};

const UscExternalPriceReducer = (
    state: UscExternalPriceReducerType = initialStateUscExternalPrice,
    action: UscExternalPriceActionsType,
): UscExternalPriceReducerType => {
    switch (action.type) {
        case USC_EXT_PRICE_SET_SHOW: {
            return { ...state, show: action.show };
        }

        case USC_EXT_PRICE_SET_DATA:
            return { ...state, data: action.data, latestPayload: action.payload };

        case USC_EXT_PRICE_FAILED: {
            return {
                ...state,
                failed: action.failed,
                latestPayload: action.payload,
                errorMessage: action.errorMessage,
            };
        }

        case USC_EXT_PRICE_SET_FETCHING: {
            return { ...state, fetching: action.fetching, errorMessage: null, failed: false };
        }

        case USC_EXT_PRICE_SET_LOCATION: {
            return { ...state, userTaxLocationId: action.locationId };
        }

        default:
            return state;
    }
};

export default UscExternalPriceReducer;
